import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  ToggleButton,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { TimeZoneLookup } from "common/Constants";
import TripNumberSearch from "common/components/search/TripNumberSearch";
import VehicleUnitNumberSearch from "common/components/search/VehicleUnitNumber";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import moment from "moment";
import { useState, useEffect } from "react";
import orgDataService from "services/orgDataService";
import { timeZone, setTimeZone } from "store/vehicleTripSlice";
import { useSelector, useDispatch } from "react-redux";

const VehicleHistoryFilters = ({
  search,
  setSearch,
  layerToggle,
  onLayerToggleChange,
  selectedRow,
  onShowAllActivityClick,
  datesModified = false,
  mapReady = true
}) => {
  const dispatch = useDispatch();
  const timezone = useSelector(timeZone);
  const [clients, setClients] = useState([]);
  useEffect(() => {
    orgDataService.getAllClients(true).then((data) => setClients(data));
  }, []);

  const onUnitNumberChange = (value) => {
    setSearch({ ...search, unitNumber: +value?.name });
  };

  return (
    <MDBox xs={12} mb={2}>
      <TripNumberSearch
        marginTop={2}
        marginRight={1}
        tripNumber={search.tripNumber}
        onChange={(value) => setSearch({ ...search, tripNumber: value?.id.toString().replace(/\D/g, "") })}
      />
      <VehicleUnitNumberSearch
        unitNumber={search.unitNumber ? { name: `${search.unitNumber}`, id: +search.unitNumber } : null}
        onChange={onUnitNumberChange}
      />
      <DateTimePicker
        sx={{ mt: 2, ml: 1 }}
        label="Start"
        ampm={false}
        timezone={TimeZoneLookup[timezone]}
        value={search.startDate}
        onChange={(newValue) => setSearch({ ...search, startDate: moment.utc(newValue)})}
      />
      <DateTimePicker
        sx={{ mt: 2, ml: 1 }}
        label="End"
        ampm={false}
        timezone={TimeZoneLookup[timezone]}
        value={search.endDate}
        onChange={(newValue) => setSearch({ ...search, endDate: moment.utc(newValue)})}
      />
      <FormControl sx={{ mt: 2, ml: 1, minWidth: 85 }}>
        <InputLabel id="timezone-label">Time Zone </InputLabel>
        <Select
          id="timezone"
          name="timezone"
          labelId="timezone-label"
          label="Time Zone"
          value={timezone}
          onChange={(e) => dispatch(setTimeZone(e.target.value))}
        >
          <MenuItem value="EST">EST</MenuItem>
          <MenuItem value="EDT">EDT</MenuItem>
          <MenuItem value="CST">CST</MenuItem>
          <MenuItem value="CDT">CDT</MenuItem>
          <MenuItem value="MST">MST</MenuItem>
          <MenuItem value="MDT">MDT</MenuItem>
          <MenuItem value="PDT">PDT</MenuItem>
          <MenuItem value="UTC">UTC</MenuItem>
        </Select>
      </FormControl>
      {(selectedRow || datesModified) && (
        <MDButton sx={{ mt: 1, ml: 1 }} onClick={onShowAllActivityClick}>
          Show All Activity
        </MDButton>
      )}
      <FormGroup sx={{ display: "inline-flex", ml: 1, mt: 2 }} row>
        <FormControlLabel
          label="Stops"
          control={<Checkbox id="stops" checked={layerToggle.stops} onChange={onLayerToggleChange} />}
        />
        <FormControlLabel
          disabled={!layerToggle.headingsEnabled}
          label="Headings"
          control={<Checkbox id="headings" checked={layerToggle.headings} onChange={onLayerToggleChange} />}
        />
        <FormControlLabel
          disabled={!layerToggle.linesEnabled}
          label="Lines"
          control={<Checkbox id="lines" checked={layerToggle.lines} onChange={onLayerToggleChange} />}
        />
        <FormControlLabel
          label="Client Points"
          control={<Checkbox id="points" checked={layerToggle.points} onChange={onLayerToggleChange} />}
        />
        {/* Held back until the map and its data are in.
            Switching basemap mid-load tears the style down while the layers for that data are
            still being built against it, which threw and took the page down with it. There is
            nothing useful to look at underneath yet either, so the control is simply not offered
            until there is. */}
        {mapReady ? (
          <FormControlLabel
            label="Satellite View"
            control={<Checkbox id="satellite" checked={layerToggle.satellite} onChange={onLayerToggleChange} />}
          />
        ) : null}
      </FormGroup>
    </MDBox>
  );
};
export default VehicleHistoryFilters;
